import { createContext } from 'react';

const PokedexContext = createContext();

export default PokedexContext;